import { render, staticRenderFns } from "./AnniversaryMission.vue?vue&type=template&id=87575f52&scoped=true"
import script from "./AnniversaryMission.vue?vue&type=script&lang=js"
export * from "./AnniversaryMission.vue?vue&type=script&lang=js"
import style0 from "./AnniversaryMission.vue?vue&type=style&index=0&id=87575f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87575f52",
  null
  
)

export default component.exports